module.exports = __webpack_public_path__ + "static/abyssal_chicken-f703d3ebb90ec0f9918cc265b0f0d0c1.jpeg";